package com.wintermar.inspection.core.ui.component.image

import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.image.util.FileModel
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.widget.ImagePicker
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.cancel
import inspection.composeapp.generated.resources.save
import org.jetbrains.compose.resources.stringResource

@Composable
fun ImagePickerDialog(
    title: String,
    description: String = "",
    files: List<FileModel> = emptyList(),
    show: Boolean = false,
    onDismiss: () -> Unit,
    onSave: (List<FileModel>) -> Unit
) {
    var fileResult by remember { mutableStateOf<List<FileModel>>(emptyList()) }
    var isError by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }

    fun handleOnDismiss() {
        onDismiss()
        fileResult = emptyList()
        isError = false
    }

    LaunchedEffect(files) {
        fileResult = files
    }

    ModalDialog(
        show = show,
        title = title,
        description = description,
        onDismiss = {
            if (isLoading) return@ModalDialog
            handleOnDismiss()
        },
        action = ModalAction.default().copy(
            showAction = true,
            widthButtonBasedOnText = true,
            withBackgroundHeader = true,
            label = stringResource(Res.string.save),
            secondLabel = stringResource(Res.string.cancel),
            disableOnClicked = isLoading,
            disableSecondOnClicked = isLoading,
            onClick = {
                isError = fileResult.isEmpty()
                if (!isError) {
                    onSave(fileResult)
                    onDismiss()
                    fileResult = emptyList()
                }
            },
            secondOnClick = {
                handleOnDismiss()
            }
        )
    ) {
        LazyColumn(
            modifier = Modifier.padding(LocalAppTheme.current.dimension.spacing.space4)
        ) {
            item {
                ImagePicker(
                    files = fileResult,
                    isError = isError,
                    onResult = {
                        fileResult = it
                        isError = fileResult.isEmpty()
                    },
                    onLoading = {
                        isLoading = it
                    })
            }
        }
    }
}
